export const PRS_MODEL = {
  TITLE: 'title',
  REPO_NAME: 'repository_name',
  STATE: 'state',
  ISSUER_ID: 'issuer_id',
  EFFECTIVE_CONTRIBUTOR_IDS: 'effective_contributor_ids',
  PR_URL: 'html_url',
  NET_SIZE_STATS_PATH_ARR: ['stats', 'pr.net.size.total'],
  TOTAL_SIZE_STATS_PATH_ARR: ['stats', 'pr.size.total']
};

export const PRS_TABLE_MODEL = {
  TITLE_CELL: 'title_cell',
  REPO_CELL: 'repo_cell',
  ISSUER_CELL: 'issuer_cell',
  STATE_CELL: 'state_cell',
  METRIC_VALUE_CELL: 'metric_value_cell',
  COMMENT_CELL: 'comment_cell',
  REVIEW_CELL: 'review_cell'
};
